const http = uni.$u.http

let data = [];
data.length
/**
 * 被指派行程列表
 * @param data
 * @returns {HttpPromise<any>}
 */
export const getSsignedItineraryList = (data ={}) => http.get('app/car/assignedItineraryList',{params: {...data}});